import React, { useState } from 'react';
import { GetAllDFMTransactionForDeveloperContact } from '../../../../../Services';

export const useFetchHistoryLog = () => {
  const [data, setData] = useState({ result: [], totalCount: 0 });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchHistoryLog = async (developerContactId, params) => {
    setLoading(true);
    try {
      const response = await GetAllDFMTransactionForDeveloperContact(
        developerContactId,
        params
      );
      setData(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return { data, error, loading, fetchHistoryLog };
};
